import { render, staticRenderFns } from "./CourierShow.vue?vue&type=template&id=26a8ff03&"
import script from "./CourierShow.vue?vue&type=script&lang=js&"
export * from "./CourierShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports